import { useQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsAdminCheck = () => {
	return useQuery({
		queryKey: QueryKeys.Integrations.MetaAds.AdminCheck(),
		queryFn: () => Api.GetMetaAdsAdminCheck().then((r) => r.data),
		staleTime: 5 * 60 * 1000,
	});
};

export const useMetaAdsAdminConnections = (enabled: boolean) => {
	return useQuery({
		queryKey: QueryKeys.Integrations.MetaAds.AdminConnections(),
		queryFn: () => Api.GetMetaAdsAdminConnections().then((r) => r.data),
		enabled,
	});
};
